import React from 'react';
import { Form, Button, Row, Col, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import CurrencyFormat from 'react-currency-format';

const ExtraMaterial = ({
  extra_materials,
  setExtraMaterials,
  deleted_extra_materials,
  setDeletedExtraMaterials,
  editable
}) => {
  const { t } = useTranslation();

  const addExtraMaterial = () => {
    const updateArray = [...extra_materials];

    updateArray.push({
      name: '',
      value: ''
    });

    setExtraMaterials(updateArray);
  };

  const handleChangeExtraMaterial = (e, k) => {
    const updateArray = [...extra_materials];
    updateArray[k][e.target.name] = e.target.value;
    setExtraMaterials(updateArray);
  };

  const deleteExtraMaterial = k => {
    const updateArray = [...extra_materials];

    if (extra_materials[k]['id']) {
      const updateArrayDeletedExtraMaterials = [...deleted_extra_materials];
      updateArrayDeletedExtraMaterials.push(extra_materials[k]['id']);
      setDeletedExtraMaterials(updateArrayDeletedExtraMaterials);
    }

    updateArray.splice(k, 1);
    setExtraMaterials(updateArray);
  };

  return (
    <>
      <Row>
        <Col>
          <h4>{t('title:extra action')}</h4>
        </Col>
      </Row>
      <Row className="mt-2 mb-3">
        <Col>
          <Button
            size="sm"
            variant="dark"
            onClick={addExtraMaterial}
            style={{ display: !editable ? 'none' : null }}
          >
            <i className="fas fa-plus" /> {t('label:add new')}
          </Button>
        </Col>
      </Row>
      <Table hover bordered responsive>
        <thead>
          <tr>
            <th className="text-center align-middle">
              {t('label:description')}
            </th>
            <th className="text-center align-middle">{t('label:value')}</th>
            <th className="text-center align-middle">{t('label:actions')}</th>
          </tr>
        </thead>
        <tbody>
          {extra_materials.map((extra, k) => (
            <tr key={k} className="mt-2">
              <td className="text-center align-middle">
                <Form.Group>
                  <Form.Control
                    name="name"
                    value={extra.name}
                    onChange={e => handleChangeExtraMaterial(e, k)}
                    required
                    disabled={!editable}
                  />
                </Form.Group>
              </td>
              <td className="text-center align-middle">
                <Form.Group>
                  <CurrencyFormat
                    name="value"
                    customInput={Form.Control}
                    decimalSeparator=","
                    thousandSeparator="."
                    fixedDecimalScale={true}
                    decimalScale={2}
                    onChange={e => handleChangeExtraMaterial(e, k)}
                    prefix="R$ "
                    value={extra.value}
                    required
                    disabled={!editable}
                  />
                </Form.Group>
              </td>
              <td className="text-center align-middle">
                <Button
                  size="sm"
                  variant="danger"
                  onClick={() => deleteExtraMaterial(k)}
                  disabled={!editable}
                >
                  <i className="fas fa-times"></i>
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
};

export default ExtraMaterial;
